import { Injectable } from '@angular/core';
import { Property, PropertySummary } from './property';
import {
    BaseIndexedDbRepository,
    SynchronizationService
} from 'libs/arch/src/lib/repositories/indexed-db';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { Filter, FilterOp } from 'libs/arch/src/lib/repositories';
import { map, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PropertiesRepository extends BaseIndexedDbRepository<PropertySummary, Property> {
    protected override readonly storeName: string = 'properties';

    constructor(
        dbService: NgxIndexedDBService,
        synchronizationService: SynchronizationService
    ) {
        super(dbService, synchronizationService);
    }

    protected override mapToEntity(dbItem: Property): Property {
        return Property.fromJson(dbItem);
    }

    protected override mapToSummary(entity: Property): PropertySummary {
        return new PropertySummary(entity.id, entity.name, entity.apcId, entity.producer?.id);
    }

    protected override getSearchableFields(): string[] {
        return ['name', 'apcId', 'producer.name'];
    }

    protected override getResourcePath(): string {
        return 'properties';
    }

    findPropertiesByProducerId(producerId: string): Observable<PropertySummary[]> {
        if (!producerId) return of([]);

        return this.executeIndexedDbQuery({
            filters: [new Filter('producerId', FilterOp.EQ, producerId)]
        }).pipe(
            map((properties) =>
                properties.map((p) => PropertySummary.fromJson(p))
            )
        );
    }
}
